import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.5 7.5H1.5V19.5H12H22.5L22.4999 7.5H19.5M12 6.81394V18.8139M12 6.81394C10.5 3.31392 6 3.83332 4.5 4.99999V17C6 16 10 15.9999 12 18.8139M12 6.81394C13.5 3.31392 18 3.83332 19.5 4.99999V17C18 16 14 15.9999 12 18.8139",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }